export default "__VITE_ASSET__D6jAn2Gz__"